<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-12 10:07:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div class="paySucceed-wrap">
    <div class="paySucceed-wrap">
      <div class="paySucceed-back"></div>
      <div class="paySucceed-top">
        <div class="paySucceed-title">缴费成功</div>
        <div class="paySucceed-text"><span></span> 您的房屋{{userPayInfo.houseInfo.building_name}}{{userPayInfo.houseInfo.unit_number}}单元{{userPayInfo.houseInfo.hourse_number}}于{{date}}在承德市双滦区兴业热力有限公司的微信平台缴费成功!</div>
        <div class="paySucceed-text"><span></span>取暖费：{{userPayInfo.areaCost.toFixed(2)}}元</div>
        <div class="paySucceed-text" v-if="payFlag"><span></span>跑漏险保费：{{userPayInfo.insuranceMoney}}元</div>
        <div class="paySucceed-hint">
          <div style="width: 0.2rem; line-height: 0.12rem;"><span style="background: #FF8888;"></span></div>
          <div style="margin-left: 0.04rem;">需要换取发票的，请在三日后，携带《用户服务卡》到我公司收费大厅领取，且不跨年度。 </div>
        </div>
        <div style="font-size: 0.12rem;color: #FF8888;margin-left:0.12rem;margin-top:0.03rem">联系电话: {{heatingLinkmanPhone}}</div>
        <div class="paySucceed-hint" v-if="payFlag">
          <div style="width: 0.11rem;  line-height: 0.12rem;"><span style="background: #FF8888;"></span></div>
          <div>
            <div style="margin-left:0.05rem">跑漏险生效后，如在有效期内发生跑漏现象并造成损失，请及时与保险公司联系。</div>
            <div style="margin-left:0.05rem;margin-top:0.03rem">联系电话: {{riskLinkmanPhone}}</div>
          </div>
        </div>
      </div>
      <div class="paySucceed-button">
        <el-button type="primary" style="background: #007B83;border:none;padding:4%" @click="goHome" >返回主页面</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  data(){
    return{
      userPayInfo:{
        houseInfo:{}
      },//用户的支付信息
      date:moment().format("YYYY年MM月DD日"),
      payFlag:false,
      riskLinkmanPhone:'',
      riskLinkmanName:'',
      heatingLinkmanName:'',
      heatingLinkmanPhone:'',
    }
  },

  methods:{
    goHome(){
      this.$router.replace({
        name:'index'
      })
    },
    async getSystemConfig(){
      const res = await this.$http.get(`${this.$url.globalurl}/systemConfig/${2}`);
      this.riskLinkmanPhone = res.result[0].risk_linkman_phone;
      this.riskLinkmanName = res.result[0].risk_linkman_name;
      this.heatingLinkmanName = res.result[0].heating_linkman_name;
      this.heatingLinkmanPhone = res.result[0].heating_linkman_phone;
    }
  },

  mounted(){
    if(this.$route.query){
      this.userPayInfo = this.$route.query;
      this.payFlag = this.$route.query.payFlag;
    }
    document.title = "缴费结果";
    this.getSystemConfig();
  }
  }
</script>
<style lang='scss' scoped>
@import url(paySucceed.scss);
</style>
